import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Car, Magnet, Sticker } from 'lucide-react';
import { Button } from './ui/Button';
export function ExpandedServices() {
  const services = [{
    title: 'Laser Embroidery',
    description: 'Unique laser embroidery technique for tone-on-tone designs on fleece and specialty fabrics.',
    icon: <Sparkles className="w-6 h-6" data-id="element-85" />,
    link: '/services/laser-embroidery'
  }, {
    title: 'Yard Signs',
    description: 'Custom yard signs for real estate, events, and campaigns. Weather-resistant and durable.',
    icon: <Sticker className="w-6 h-6" data-id="element-86" />,
    link: '/services/yard-signs'
  }, {
    title: 'Vehicle Decals',
    description: 'Professional vehicle wraps, decals, and window graphics for walls, windows, and vehicles.',
    icon: <Car className="w-6 h-6" data-id="element-87" />,
    link: '/services/vehicle-decals'
  }, {
    title: 'Vehicle Magnets',
    description: 'Removable magnetic signs for cars, trucks, and vans. Perfect for business advertising.',
    icon: <Magnet className="w-6 h-6" data-id="element-88" />,
    link: '/services/vehicle-magnets'
  }, {
    title: 'Decals',
    description: 'Custom decals for any surface. Durable, weather-resistant, and available in any size.',
    icon: <Sticker className="w-6 h-6" data-id="element-89" />,
    link: '/services/decals'
  }];
  return <section className="py-24 bg-white border-t border-gray-100" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-93">
            Expand Your Brand
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-94">
            Additional Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-95">
            Beyond our core offerings, we provide specialized services to meet
            all your branding needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-96">
          {services.map((service, index) => <Link key={index} to={service.link} className="group bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:border-wh-pink hover:shadow-md transition-all duration-300" data-id="element-97">
              <div className="flex items-start gap-4" data-id="element-98">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gray-50 text-gray-600 group-hover:bg-pink-50 group-hover:text-wh-pink flex items-center justify-center transition-colors" data-id="element-99">
                  {service.icon}
                </div>
                <div className="flex-1" data-id="element-100">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-101">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-102">
                    {service.description}
                  </p>
                </div>
              </div>
            </Link>)}
        </div>

        <div className="text-center" data-id="element-103">
          <Link to="/services" data-id="element-104">
            <Button variant="outline" size="lg" data-id="element-105">
              View All Services
            </Button>
          </Link>
          <p className="text-sm text-gray-500 mt-3" data-id="element-106">
            More ways to support your brand beyond apparel.
          </p>
        </div>
      </div>
    </section>;
}